export default "__VITE_ASSET__DLzIpu$y__"